import { AdminSettingsEnrollNewCompanyParam } from "features/admin/core/admin.params";
import { useAppDispatch, useAppSelector } from "features/config/hooks";
import { MaterialInput } from "features/shared/presentation/components";
import React, { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import {
  adminSettingsEnrollNewCompany,
  AdminSettingsEnrollNewCompanyState,
  selectAdminSettingsEnrollNewCompany,
} from "../slices/admin-settings-enroll-new-company.slice";
import { adminSettingsEditUserMaterialSupplierCustomer } from "../slices/admin-settings-edit-user-meterial-supplier-customer.slice";

export interface AdminSettingsEditUserEnrollCompanyModalProps {
  open: boolean;
  onClose: () => void;
}

export function AdminSettingsEditUserEnrollCompanyModal(
  props: AdminSettingsEditUserEnrollCompanyModalProps
) {
  const dispatch = useAppDispatch();
  const companyEnrollmentState = useAppSelector(
    selectAdminSettingsEnrollNewCompany
  );
  const [companyState, setCompanyState] = useState<
    AdminSettingsEnrollNewCompanyParam["companyState"]
  >({
    companyCode: "",
    companyName: "",
    companyAddress: "",
    companyContact: "",
    companyOperatingHours: "",
    companyOperatingDays: "",
  });

  useEffect(() => {
    if (
      companyEnrollmentState.status ===
      AdminSettingsEnrollNewCompanyState.success
    ) {
      dispatch(adminSettingsEditUserMaterialSupplierCustomer());
      document.body.classList.remove("overflow-hidden");
      props.onClose();
    }
  }, [companyEnrollmentState.status]);

  const handleCompanyEnrollment = () => {
    const enrollmentData: AdminSettingsEnrollNewCompanyParam = {
      enrollmentType: "company",
      companyState: companyState,
    };

    dispatch(adminSettingsEnrollNewCompany(enrollmentData));
  };

  const handleFieldChange = (e: {
    target: { name: string; value: string };
  }) => {
    setCompanyState({
      ...companyState,
      [e.target.name]: e.target.value,
    });
  };

  if (props.open) {
    document.body.classList.add("overflow-hidden");
  } else {
    document.body.classList.remove("overflow-hidden");
    return null;
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 font-[Roboto] px-3">
      <div
        className="fixed inset-0 bg-black opacity-50"
        onClick={() => props.onClose()}
      ></div>
      <div className="bg-white rounded-lg shadow-lg p-6 z-10 space-y-4 w-full h-full md:w-1/4 md:h-4/5 overflow-y-auto">
        <div className="flex flex-row items-center justify-between">
          <h2 className="text-xl font-bold">Company Enrollment</h2>
          <button
            className="text-2xl text-black"
            onClick={() => {
              document.body.classList.remove("overflow-hidden");
              props.onClose();
            }}
          >
            <IoMdClose />
          </button>
        </div>

        <div className="space-y-2">
          <>
            <p className="font-semibold">Company Code:</p>
            <MaterialInput
              fullWidth
              colorTheme={"black"}
              size="small"
              placeholder="Enter company code"
              name={"companyCode"}
              onChange={handleFieldChange}
            />
            <p className="text-xs text-gray-600">Enter the company code</p>
          </>

          <>
            <p className="font-semibold">Company Name:</p>
            <MaterialInput
              fullWidth
              colorTheme={"black"}
              size="small"
              placeholder="Enter company name"
              name={"companyName"}
              onChange={handleFieldChange}
            />
            <p className="text-xs text-gray-600">
              Enter the name of the company you want to enroll
            </p>
          </>

          <>
            <p className="font-semibold">Company Address:</p>
            <MaterialInput
              fullWidth
              colorTheme={"black"}
              size="small"
              placeholder="Enter company address"
              name={"companyAddress"}
              onChange={handleFieldChange}
            />
            <p className="text-xs text-gray-600">
              Enter the address of the company
            </p>
          </>

          <>
            <p className="font-semibold">Company Contact Number:</p>
            <MaterialInput
              fullWidth
              colorTheme={"black"}
              size="small"
              placeholder="Enter company contact"
              name={"companyContact"}
              onChange={handleFieldChange}
            />
            <p className="text-xs text-gray-600">
              Enter the contact number of the company
            </p>
          </>

          <>
            <p className="font-semibold">Company Operating Hours:</p>
            <MaterialInput
              fullWidth
              colorTheme={"black"}
              size="small"
              placeholder="Enter company operating hours"
              name={"companyOperatingHours"}
              onChange={handleFieldChange}
            />
            <p className="text-xs text-gray-600">
              ex: 10am to 7pm. Please follow the text format for consistency
            </p>
          </>

          <>
            <p className="font-semibold">Company Operating day/s:</p>
            <MaterialInput
              fullWidth
              colorTheme={"black"}
              size="small"
              placeholder="Enter company operating day/s"
              name={"companyOperatingDays"}
              onChange={handleFieldChange}
            />
            <p className="text-xs text-gray-600">
              ex: Mon to Fri. Please follow the text format for consistency
            </p>
          </>

          <ul className="list-disc list-inside text-xs text-gray-600">
            <span>Note: </span>
            <li>You can only enroll companies that are not already enrolled</li>
            <li>
              Once you click on the enroll button, the company will be added
              immediately
            </li>
            <li>
              Please ensure that all data fields are not empty. I did not put
              required validations for this form
            </li>
          </ul>
          <button
            className="flex w-full bg-button p-3 rounded-md text-white font-semibold justify-center items-center"
            type="button"
            onClick={handleCompanyEnrollment}
          >
            Enroll
          </button>
        </div>
      </div>
    </div>
  );
}
